import { createAction, EmptyActionCreator } from 'redux-act';

const MODULE_ID = 'FD_BASKET_';

const createBasketAction = <T>(type: string) =>
  createAction<T>(`${MODULE_ID}${type}`);

export const setBasket = createBasketAction<WebOrder.State.Basket>(
  'SET_BASKET',
);
export const updateBasket = createBasketAction<Partial<WebOrder.State.Basket>>(
  'UPDATE_BASKET',
);

export const createBasketSnapshot = createBasketAction<
  WebOrder.State.BasketSnapshot
>('BASKET_SNAPSHOT');

export const setValidationErrors = createAction<
  WebOrder.State.BasketValidationError[]
>('SET_VALIDATION_ERRORS');

export const setBasketError = createAction<Error>('SET_BASKET_ERROR');
export const selectPayment = createBasketAction<{ paymentId?: string }>(
  'SELECT_PAYMENT',
);
export const selectRequestedTime = createBasketAction<{
  requestedTime?: string;
}>('SELECT_REQUESTED_TIME');

export const setStatus = createBasketAction<{
  status: WebOrder.State.Basket['status'];
  error?: Error;
}>('SET_STATUS');

export const setOrderLoading = createBasketAction<boolean>('SET_ORDER_LOADING');
export const setSubmittedOrder = createBasketAction<
  WebOrder.State.BasketSubmittedOrder
>('SET_SUBMITTED_ORDER');
export const keepCreatedOrder = createBasketAction<{
  [uniqueKey: string]: WebOrder.State.BasketCreatedOrder;
}>('KEEP_CREATED_ORDER');

export const clearCreatedOrders = createBasketAction<void>(
  'CLEAR_CREATED_ORDERS',
);

//#region just events

export const startCheckoutFlow = createBasketAction(
  'START_CHECKOUT_FLOW',
) as EmptyActionCreator;
export const continueCheckoutFlow = createBasketAction(
  'CONTINUE_CHECKOUT_FLOW',
) as EmptyActionCreator;
export const cancelCheckoutFlow = createBasketAction(
  'CANCEL_CHECKOUT_FLOW',
) as EmptyActionCreator;

//#endregion
